export default __webpack_public_path__ + "static/media/brand.47467fb3.svg";